import React from 'react';
import SignOutButton from './SignOutButton';
import LKButton from './LKButton';

const StudentUserButtons = ({ signOut, history }) => (
  <div className="header-user__btns">
    <LKButton history={history} />
    <SignOutButton signOut={signOut} />
  </div>
);

export default StudentUserButtons;
